<template>
	<div>
		<div class="row">
			<div class="col-4">
				<!-- <img src="http://www.dermalina.com/wp-content/uploads/2020/12/no-image.jpg" height="110px" width="120px" alt=""> -->
				<svg width="123" height="123" viewBox="0 0 123 123">
					<rect x="0.580078" y="0.890137" width="121.749" height="121.749" rx="8" style="fill:#dbdee0" />
					<text x="22" y="65" fill="#757778" style="font-weight: 700;font-size:18px;opacity:80%">No Image</text>
				</svg>
			</div>
			<div class="col-8">
				<h5 class="mt-3 text-dark" style="color:black !important">{{lead.company}} {{getLead}}</h5>
				<p class="text-dark" style="color:black !important">{{lead.name}}</p>
			</div>
		</div>
		<hr class="mb-2">
		<ul class="nav nav-pills nav-fill" role="tablist" id="tabs" style="font-size:14px;font-weight:500;">
			<li>
				<button style="padding: 5px 7px;" class="rounded mt-1" v-bind:class="[ tab==1 ? 'active' : '']" @click="tabs(1)">Informations</button>
			</li>
			<li>
				<button style="padding: 5px 7px;" class="rounded mt-1" v-bind:class="[ tab==2 ? 'active' : '']" @click="tabs(2)">Prospection Questions</button>
			</li>
			<li>
				<button style="padding: 5px 7px;" class="rounded mt-1" v-bind:class="[ tab==3 ? 'active' : '']" @click="tabs(3)">Demo Notes</button>
			</li>
			<li>
				<button style="padding: 5px 7px;" class="rounded mt-1" v-bind:class="[ tab==4 ? 'active' : '']" @click="tabs(4)">Notes</button>
			</li>
			<li>
				<button style="padding: 5px 7px;" class="rounded mt-1" v-bind:class="[ tab==5 ? 'active' : '']" @click="tabs(5)">Calls</button>
			</li>
		</ul>
		<hr>

		<!-- Informations -->
		<div v-if="tab==1">
			<div class="row">
				<div class="col-6">
					<div>
						<span class="color-default font-weight-bold">Phone Number</span>
						<br>
						<span style="color:black">{{lead.phone}}</span>
					</div>
				</div>
				<div class="col-6">
					<div>
						<span class="color-default font-weight-bold">Email Address</span>
						<br>
						<span style="color:black">{{lead.email}}</span>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-6">
					<div>
						<span class="color-default font-weight-bold">Country</span>
						<br>
						<span style="color:black">{{lead.country}}</span>
					</div>
				</div>
				<div class="col-6">
					<div>
						<span class="color-default font-weight-bold">Website</span>
						<br>
						<span style="color:black">{{lead.company_url}}</span>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-6">
					<div>
						<span class="color-default font-weight-bold">Implementation</span>
						<br>
						<span style="color:black">{{lead.implement_date}}</span>
					</div>
				</div>
				<div class="col-6">
					<div>
						<span class="color-default font-weight-bold">Request Date</span>
						<br>
						<span style="color:black">{{lead.created_at | formatDate}}</span>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-6">
					<div>
						<span class="color-default font-weight-bold">Hear About Us</span>
						<br>
						<span style="color:black">{{lead.hear_about}}</span>
					</div>
				</div>
				<div class="col-6">
					<span class="color-default font-weight-bold">Services</span>
					<span style="display: block;color:black;" v-if="lead.rental == 1">• Linen Rental</span>
					<span style="display: block;color:black;" v-if="lead.dry_cleaning == 1">• Dry Cleaning</span>
					<span style="display: block;color:black;" v-if="lead.cog == 1">• Customer Owned Goods</span>
				</div>
			</div>
			<div class="row">
				<div class="col-6">
					<div>
						<span class="color-default font-weight-bold">Weight to Process</span>
						<br>
						<span style="color:black">-</span>
					</div>
				</div>
				<div class="col-6">
					<div>
						<span class="color-default font-weight-bold">Key Challenges</span>
						<br>
						<span style="color:black">-</span>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-6">
					<span class="color-default font-weight-bold">Software</span>
					<br>
					<span style="color:black" >{{ formData.software }}</span>


				</div>
				<div class="col-6" v-if="lead.status=='3'">
					<span class="color-default font-weight-bold">Rejection Reason</span>
					<br>
					<span style="color:black">{{lead.reject_msg}}</span>
				</div>
			</div>
			 
			<div v-if="lead.additional_info != null">
				<br>
				<hr>
				<div class="row mt-2 mb-1">
					<div class="col-12">
						<h5 class="color-default font-weight-bold f-24">Additional Information</h5>
					</div>
				</div>
				<div class="row">
					<div class="col-6">
						<div>
							<span class="color-default font-weight-bold">Linkedin</span>
							<br>
							<span v-if="lead.additional_info.linked_in" style="color:black">{{lead.additional_info.linked_in}}</span>
							<span v-else style="color:black">-</span>
						</div>
					</div>
					<div class="col-6">
						<div>
							<span class="color-default font-weight-bold">Google Plus</span>
							<br>
							<span v-if="lead.additional_info.goole_plus" style="color:black">{{lead.additional_info.goole_plus}}</span>
							<span v-else style="color:black">-</span>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-6">
						<div>
							<span class="color-default font-weight-bold">Facebook</span>
							<br>
							<span v-if="lead.additional_info.facebook" style="color:black">{{lead.additional_info.facebook}}</span>
							<span v-else style="color:black">-</span>
						</div>
					</div>
					<div class="col-6">
						<div>
							<span class="color-default font-weight-bold">Twitter</span>
							<br>
							<span v-if="lead.additional_info.twitter" style="color:black">{{lead.additional_info.twitter}}</span>
							<span v-else style="color:black">-</span>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-6">
						<div>
							<span class="color-default font-weight-bold">Job Title</span>
							<br>
							<span v-if="lead.additional_info.job_title"  style="color:black">{{lead.additional_info.job_title}}</span>
							<span v-else style="color:black">-</span>
						</div>
					</div>
					<div class="col-6">
						<div>
							<span class="color-default font-weight-bold">Close Date</span>
							<br>
							<span v-if="lead.additional_info.close_date" style="color:black">{{lead.additional_info.close_date}}</span>
							<span v-else style="color:black">-</span>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-6">
						<div>
							<span class="color-default font-weight-bold">Number of Decision Makers</span>
							<br>
							<span v-if="lead.additional_info.number_of_decion_makers" style="color:black">{{lead.additional_info.number_of_decion_makers}}</span>
							<span v-else style="color:black">-</span>
						</div>
					</div>
					<div class="col-6">
						<div>
							<span class="color-default font-weight-bold">Number of Employees</span>
							<br>
							<span v-if="lead.additional_info.number_of_employees" style="color:black">{{lead.additional_info.number_of_employees}}</span>
							<span v-else style="color:black">-</span>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-6">
						<div>
							<span class="color-default font-weight-bold">Postal Code</span>
							<br>
							<span v-if="lead.additional_info.postal_code" style="color:black">{{lead.additional_info.postal_code}}</span>
							<span v-else style="color:black">-</span>
						</div>
					</div>
					<div class="col-6">
						<div>
							<span class="color-default font-weight-bold">Street Address</span>
							<br>
							<span v-if="lead.additional_info.street_address" style="color:black">{{lead.additional_info.street_address}}</span>
							<span v-else style="color:black">-</span>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-6">
						<div>
							<span class="color-default font-weight-bold">Timezone</span>
							<br>
							<span v-if="lead.additional_info.timezone" style="color:black">{{lead.additional_info.timezone}}</span>
							<span v-else style="color:black">-</span>
						</div>
					</div>
					<div class="col-6">
						<div>
							<span class="color-default font-weight-bold">Year founded</span>
							<br>
							<span v-if="lead.additional_info.year_founded" style="color:black">{{lead.additional_info.year_founded}}</span>
							<span v-else style="color:black">-</span>
						</div>
					</div>
				</div>
			</div>
			<br>
		</div>



		<!-- Onboarding Questions -->
		<div v-if="tab == 2">
			<div v-if="loading">
				<!-- Show a loading indicator -->
				<p class="text-center">Loading...</p>
			</div>
			<div v-else-if="leadWithData && leadWithData.lead_questionnaires && leadWithData.lead_questionnaires.length > 0">
				<div v-for="questionnaire in leadWithData.lead_questionnaires" :key="questionnaire.id">
					<p class="color-default font-weight-bold">{{ questionnaire.question }}</p>
					<div v-for="answer in questionnaire.lead_questionnaire_answers" :key="answer.id">
						<div v-if="answer.answer.includes('?ques_id=')">
							<span class="color-default font-weight-bold">&bull;</span>
							{{ answer.answer.split('?ques_id=')[0] }}
						</div>
						<div v-else-if="questionnaire.type !== 'track_rental_soiled_linen_rental'">
							<span class="color-default font-weight-bold">&bull;</span>
							{{ answer.answer }}
						</div>
						<div v-else>
							<textarea v-model="answer.answer" rows="4" cols="50"></textarea>
						</div>
					</div>
					<hr>
				</div>
			</div>
			<div v-else>
				<p class="text-center">No Data Found!</p>
			</div>
		</div>


		<!-- Demo Notes-->
		<div v-if="tab==3">
			<div class="vtl" v-for="note in demo_notes" :key="note.id">
				<div class="event">
					<strong class="edate">{{note.created_at | formatDate}}</strong><span v-if="note.completed==1" style="background-color: #d4f3b6;" class="text-success rounded-pill px-3  float-right">Completed</span>
					<p style="white-space: pre-line" class="etxt">{{note.schedule_note}}</p>
				</div>
			</div>
			<div class="text-center" v-if="demo_notes==''">
				<h4 class="my-5 py-5">No Content</h4>
			</div>
		</div>

		<!-- Notes-->
		<div v-if="tab==4">
			<div class="vtl" v-for="note in notes" :key="note.id">
				<div class="event">
					<strong class="edate">{{note.created_at | formatDate}}</strong>
					<p style="white-space: pre-line" class="etxt">{{note.note}}</p>
				</div>
			</div>
			<div class="text-center" v-if="notes==''">
				<h4 class="my-5 py-5">No Content</h4>
			</div>
		</div>

		<div v-if="tab==5">

			<div class="vtl" v-for="call in lead.lead_calls" :key="call.id">
				<div class="event">
					<strong class="edate">{{call.call_end_time | formatDate}}</strong>
					<p style="white-space: pre-line" class="etxt"><b>{{call.caller_name}}</b> call lasted for <b>{{call.duration}}</b> seconds and ended at <b>{{call.call_end_time | formatDate}}</b>. </p>
				</div>
			</div>
			<div class="text-center" v-if="lead.lead_calls == null || lead.lead_calls.length<1">
				<h4 class="my-5 py-5">No Calls Found</h4>
			</div>
		</div>

	</div>
</template>
<script>
	import axios from 'axios';
	import moment from 'moment';
	import DateRangePicker from 'vue2-daterange-picker';
    import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';

	Vue.filter('formatDate', function (value) {
		if (value != '0000-00-00 00:00:00' && value != null) {
			return moment(String(value)).format('MMM DD, Y LT')
		}
	});
	export default {
		components: {
		DateRangePicker
		},
		props: [
			'action', 'formData'
		],
		data: function () {
			return {
				tab: 1,
				lead: '',
				onBoarding: '',
				demo_notes: '',
				notes: '',
				role:0,
				leadWithData: null,
				loading: false,
				 filters: {
				   deliveryDate: { startDate: null, endDate: null }
				},
			};
		},
		computed: {

			getLead: function () {
				 const permission = {
      headers: {
        'X-Permission': 'lead_detail' 
      }
    };
				axios.get('/admin/users/getdemo?id=' + this.formData.user,permission)
					.then((response) => {
						let data = response.data.data;
						this.tab = 1;
						if (data != null) {
							this.lead = data;
						}
						if (response.data.board != null) {
							this.onBoarding = response.data.board;
						}
						if (response.data.demo != null) {
							this.demo_notes = response.data.demo;
						}
						if (response.data.notes != null) {
							this.notes = response.data.notes;
						}
					});
			},

		},
		mounted: function(){
			this.role= JSON.parse(localStorage.getItem('role'));
		},
		methods: {
			tabs(event) {
				if (event == 1) {
					this.tab = 1;
				} else if (event == 2) {
					this.tab = 2;
					this.getLeadQuestionnaire();
				} else if (event == 3) {
					this.tab = 3;
				}
				else if (event == 4) {
					this.tab = 4;
				}
				else if (event == 5) {
					this.tab = 5;
				}
			},
			getLeadQuestionnaire() {
			this.loading = true;
			  const permission = {
      headers: {
        'X-Permission': 'lead_prospection_question' 
      }
    };
			axios.get(`/admin/users/get-lead-questionnaire/${this.formData.user}`,permission)
				.then((response) => {
					this.leadWithData = response.data.leadWithData;
					this.loading = false;
				})
				.catch((error) => {
					console.error(error);
					this.loading = false;
				});
			}
		}
	}
</script>
<style>
	#tabs .nav-link {
		background: transparent;
		color: rgb(66, 64, 64);
	}

	#tabs a:hover {}

	#tabs .active {
		background-color: #48a6a6 !important;
		color: white;
	}


	/* (A) "SET" THE TIMELINE CONTAINER */
	.vtl {
		/* (A1) RELATIVE POSITION NECESSARY TO PROPERLY POSITION TIMELINE LATER */
		position: relative;
		/* (A2) RESERVE MORE SPACE TO THE LEFT FOR THE TIMELINE */
		padding: 10px 0px 10px 50px;
		/* (A3) OPTIONAL WIDTH RESTRICTION */
		max-width: 1000px;
	}

	/* (B) DRAW TIMELINE USING ::BEFORE */
	.vtl::before {
		/* (B1) DRAW THE TIMELINE */
		content: '';
		width: 3px;
		background-color: #f4f8fa;
		/* (B2) POSITION IT TO THE LEFT */
		position: absolute;
		top: 0;
		bottom: 0;
		left: 15px;
	}

	/* (C) STYLES FOR THE EVENTS */
	div.event {
		padding: 20px 30px;
		background-color: #f2f5f7;
		position: relative;
		border-radius: 6px;
		margin-bottom: 10px;
	}

	/* (D) STYLES FOR THE DATE & TEXT */
	strong.edate {
		font-size: 14px;
		font-weight: bold;
		color: #48a6a6;
	}

	p.etxt {
		margin: 10px 0 0 0;
		color: #222;
	}

	/* (E) ADD "SPEECH BUBBLE TRIANGLE" TO THE EVENTS */
	div.event::before {
		content: '';
		border: 10px solid transparent;
		border-right-color: #f2f5f7;
		border-left: 0;
		position: absolute;
		top: 20%;
		left: -10px;
	}

	/* (F) ADD A CIRCLE ON THE TIMELINE TO INDICATE AN EVENT */
	div.event::after {
		content: '';
		background: #f4f8fa;
		border: 4px solid #48a6a6;
		width: 13px;
		height: 13px;
		border-radius: 50%;
		position: absolute;
		top: 25%;
		left: -40px;
	}
	.vue-daterange-picker{
		width: 60%;
		padding: 10px;
	}
	
</style>